import { useQuery, QueryErrorResetBoundary } from "react-query"
import { ErrorBoundary } from "react-error-boundary"
import Header from "../../../components/Header"
import { HeadingPages } from "../../../components/HeadingPages"
import { api } from "../../../services/api"
import { Alert, AlertIcon, Button, Table, Tbody, Td, Th, Thead, Tr, useToast } from "@chakra-ui/react"
import { Layout } from "../../../components/Layout"
import { Loader } from "../../../components/ComponentLoader/Loader"
import { format } from "date-fns"
import { capitalize } from "../../../utils/capitalize"
import { ModalObs } from "./ModalObs"

async function getRetificacoesConcluidas() {
  const response = await api.get("/site/v2/fluxo-layout/listar-retificacoes-concluidas")

  return response.data.map((item) => {
    return {
      ...item,
      data_solicitacao: format(new Date(item.data_solicitacao), "dd/MM/yyyy HH:mm"),
      prazo_entrega: capitalize(item.prazo_entrega),
      nome_vendedor: capitalize(item.nome_vendedor),
      cor: capitalize(item.cor),
    }
  })
}

export function RetificacoesConcluidas() {
  const toast = useToast({
    position: "top",
    duration: 5000,
    isClosable: true,
  })

  const { data, isLoading } = useQuery({
    queryFn: getRetificacoesConcluidas,
    queryKey: "getRetificacoesConcluidas",
    onError: (error) => {
      console.log(error)
      toast({
        title: "Erro ao buscar retificações concluídas",
        status: "error",
      })
    },
  })

  console.log(data)

  return (
    <>
      <HeadingPages name="Retificações Concluídas" />

      <Layout>
        {isLoading && <Loader />}

        {!isLoading && data && data.length > 0 && (
          <Table className="table" size="sm">
            <Thead>
              <Tr>
                <Th scope="col">Pedido</Th>
                <Th scope="col">Nota</Th>
                <Th scope="col">Solicitação</Th>
                <Th scope="col">Gravação</Th>
                <Th scope="col">Cor</Th>
                <Th scope="col">Vendedor</Th>
                <Th scope="col">Prazo</Th>
                <Th scope="col">Referência</Th>
                <Th scope="col">Obs</Th>
                <Th scope="col">Link da Logo</Th>
              </Tr>
            </Thead>
            <Tbody>
              {data.map((item, index) => (
                <Tr key={index}>
                  <Td>{item.numero_pedido}</Td>
                  <Td>{item.numero_nota}</Td>
                  <Td>{item.data_solicitacao}</Td>
                  <Td>{item.gravacao}</Td>
                  <Td>{item.cor}</Td>
                  <Td>{item.nome_vendedor}</Td>
                  <Td>{item.prazo_entrega}</Td>
                  <Td>{item.referencia}</Td>
                  <Td>
                    {item.observacao ? (
                      <ModalObs pedido={item.numero_pedido} obs={item.observacao} />
                    ) : (
                      "Sem observações"
                    )}
                  </Td>
                  <Td>
                    <Button
                      as="a"
                      href={item.link_logo}
                      target="_blank"
                      colorScheme="blue"
                      size="sm"
                      variant="outline"
                      isExternal
                    >
                      Visualizar
                    </Button>
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}

        {!isLoading && data && data.length === 0 && (
          <Alert status="info">
            <AlertIcon />
            Não há retificações concluídas
          </Alert>
        )}
      </Layout>
    </>
  )
}
